const NAVIGATION_BUILD = Symbol('NAVIGATION_BUILD');
const NAVIGATION_SET_IN_STORE = Symbol('NAVIGATION_SET_IN_STORE');

/**
 * @param {number} currentChannelId
 * @return {{type, payload: {channels: *}}}
 */
export const navigationBuildAction = (currentChannelId) => ({
  type: NAVIGATION_BUILD,
  payload: { currentChannelId },
});

/**
 * @param {navigationItemModel[]} navigation
 * @return {{type, payload: {navigation: *}}}
 */
export const navigationSetInStoreAction = (navigation) => ({
  type: NAVIGATION_SET_IN_STORE,
  payload: { navigation },
});
